module.exports = __webpack_public_path__ + "img/134.6d3b53f4.jpg";